import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import routes from './routes/routes';
import PasswordProtection from './components/PasswordProtection/PasswordProtection';

const renderRoutes = (routes) => {
  return routes.map((route, index) => {
    const { path, element, children, index: isIndex } = route;
    
    if (isIndex) {
      return <Route key={`route-${index}`} index element={element} />;
    }
    
    if (children) {
      return (
        <Route key={`route-${index}`} path={path} element={element}>
          {renderRoutes(children)}
        </Route>
      );
    }
    
    return <Route key={`route-${index}`} path={path} element={element} />;
  });
};

const App = () => {
  const isPasswordProtected = process.env.REACT_APP_PASSWORD_PROTECTED === 'true';
  const [hasAccess, setHasAccess] = useState(!isPasswordProtected);

  // Check if user already has access (stored in sessionStorage)
  useEffect(() => {
    if (isPasswordProtected) {
      const accessGranted = sessionStorage.getItem('dev_access_granted') === 'true';
      setHasAccess(accessGranted);
    }
  }, [isPasswordProtected]);

  const handleAccessGranted = () => {
    setHasAccess(true);
  };

  // Show password protection if enabled and access not granted
  if (isPasswordProtected && !hasAccess) {
    return <PasswordProtection onAccessGranted={handleAccessGranted} />;
  }

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {renderRoutes(routes)}
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;